import { Course } from './course';
import { Language } from './language';
import { OrderSpecialRequest } from './order-special-request';
import { Package } from './package';
import { User } from './user';
import { Visibility } from './visibility';

/** E learning. */
export class ELearning {
  constructor(data) {
    this.id = data.id;
    this.confirmationId = data.confirmationId;
    this.statusId = data.statusId;
    this.status = data.status;
    this.userId = data.userId;
    this.isNewSystem = data.isNewSystem;
    this.registerUserId = data.registerUserId;
    this.sourceId = data.sourceId;
    this.source = data.source;
    this.examScore = data.examScore;
    this.certificateNumber = data.certificateNumber;
    this.certSendDate = data.certSendDate;
    this.createdDate = data.createdDate;
    this.editedDate = data.editedDate;
    this.isActive = data.isActive;
    this.balance = data.balance;
    this.orderItem = data.orderItem;
    this.orderId = data.orderId;
    this.allocationDate = data.allocationDate;
    this.registrationSource = data.registrationSource;
    this.studentAccessPage = data.studentAccessPage;

    /** @type {User} */
    this.user = data.user;

    /** @type {User} */
    this.registerUser = data.registerUser;

    /** @type {Package} */
    this.package = data.package;

    /** @type {Course} */
    this.courseInfo = data.courseInfo;

    /** @type {Language | null} */
    this.language = data.language;

    /** @type {boolean} */
    this.isVisible = data.isVisible;
  }
}

export class ELearningDetail extends ELearning {
  constructor(data) {
    super(data);
    this.payment = data.payment;
    this.refundPayment = data.refundPayment;

    /** @type {OrderSpecialRequest[]} */
    this.orderSpecialRequests = data.orderSpecialRequests;

    this.hasPreBoughtLaminatedCard = data.hasPreBoughtLaminatedCard;

    /** @type {Package | null} */
    this.laminatedCardPackage = data.laminatedCardPackage;
  }
}
